/** The server tool whose completion moves the app to a page. */
export const NAVIGATE_TOOL_NAME = 'navigate_to';

/**
 * The in-app path from a completed navigate_to call, or null when the output
 * is not a navigation (an MCP-style text reply, an error, or anything that is
 * not a path starting with "/"). Protocol-relative paths are refused.
 */
export function parseNavigation(output: string | null | undefined): string | null {
    if (!output) {
        return null;
    }

    try {
        const parsed = JSON.parse(output) as {path?: unknown; navigated?: unknown};
        const path = typeof parsed.path === 'string' ? parsed.path.trim() : '';
        if (!path.startsWith('/') || path.startsWith('//')) {
            return null;
        }
        return path;
    } catch {
        return null;
    }
}
